import styled from 'styled-components';

export const  StyledMintAmountPicker = styled.div `
  padding: 0px 10px;
  gap: 4px;
  border: none;
  display: grid;
  font-family: "BebasNeue";
  grid-column: 1;
  grid-row: 5 / 13;  
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(8, 1fr);

  @media (max-width: 1050px) {
    gap: 1px;
  }

  @media (max-width: 850px) {
    gap: 0;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 1.8rem;    
    grid-template-rows: repeat(7, 1fr);
    grid-row: 5 / 12;
    padding: 0px;
  }
`

export const IndicatorContainer = styled.div`
  border: 4px solid white;
  padding: 5px;
  display: grid;
  grid-column: 1;
  grid-row: 1 / 3;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);

  @media (max-width: 1420px) {
    border-width: 3px;
  }

  @media (max-width: 850px) {
    border-width: 2px;
  }

  .label {
    display: flex;
    width: 100%;
    padding: 5px 15px;
    align-items: center;
    justify-content: start;
    font-size: 24px;
    font-weight: bold;
    color: white;
    letter-spacing: 5px;

    @media (max-width: 3300px) {
      font-size: 2.8rem;
    }
  
    @media (max-width: 1800px) {
        font-size: 2.2rem;
    }
  
    @media (max-width: 1420px) {
        font-size: 1.4rem;
    }
  
    @media (max-width: 1110px) {
        font-size: 1rem;
    }

    @media (max-width: 850px) {
      font-size: 0.6rem;
    }

    @media (max-width: ${({ theme }) => theme.mobile}) {
            font-size: 1.8rem;
    }
  }

  .indicator {
    display: flex;
    width: 100%;
    padding: 5px 15px;
    align-items: center;
    justify-content: start;
    font-size: 36px;
    font-weight: bold;
    color: ${({ theme }) => theme.background};
    background-color: white;

    @media (max-width: 3300px) {
      font-size: 3rem;
    }
  
    @media (max-width: 1800px) {
        font-size: 2.4rem;
    }
  
    @media (max-width: 1420px) {
        font-size: 1.5rem;
    }
  
    @media (max-width: 1110px) {
        font-size: 1.1rem;
    }

    @media (max-width: 850px) {
      font-size: 0.7rem;
    }

    @media (max-width: ${({ theme }) => theme.mobile}) {
            font-size: 2rem;
    }
  }
`

export const SliderContainer = styled.div`
  display: grid;
  grid-column: 1;
  grid-row: 3 / 6;
  padding-top: 5%;
  padding-bottom: 5px;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    padding-top: 5%;
    font-size: 2rem;
  }
`

export const ButtonContainer = styled.div`
  display: grid;
  grid-column: 1;
  grid-row: 6 / 8;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    margin: 10px 0px;
  }
`

export const ButtonText = styled.span`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  div {
    // padding-left: 8px;
    // padding-right: 8px;
  }

  @media (max-width: 3300px) {
    font-size: 3rem;
  }

  @media (max-width: 1800px) {
      font-size: 2.4rem;
  }

  @media (max-width: 1420px) {
      font-size: 1.8rem;
  }

  @media (max-width: 1110px) {
      font-size: 1.2rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 1rem;
  }
`

export const ButtonArrow = styled.img `
  width: 15px;
  object-fit: cover;

  @media (max-width: 3300px) {
    width: 55px;
  }

  @media (max-width: 1800px) {
      width: 45px;
  }

  @media (max-width: 1420px) {
      width: 35px;
  }

  @media (max-width: 1110px) {
      width: 25px;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    width: 15px;
  }
`
